import { WasteReturnRegFieldKeys } from "../../customTypings/spreadsheetTemplate/SpreadsheetTemplate";

import { EA_LIST_SOURCE_DEFAULTS } from "./eaListSourceDefaults";

import { formatListSourceColOpenValueRange } from "./mappingRangeAddress";

export type EaWasteReturnListSourceRowKey =
    | "geographySource"
    | "ewcSource"
    | "disposalRecoveryReceivedSource"
    | "disposalRecoveryRemovedSource"
    | "facilityOperationSource"
    | "technicalCompetenceSource";

export interface IEaWasteReturnListSourceDefinition {
    rowKey: EaWasteReturnListSourceRowKey;
    label: string;
    regFieldKey: string;
    defaultSheet: string;
    defaultAddress: string;
    defaultEndRow: number;
}

export const EA_WASTE_RETURN_LIST_SOURCE_DEFINITIONS: IEaWasteReturnListSourceDefinition[] = [
    {
        rowKey: "geographySource",
        label: "Geography code",
        regFieldKey: WasteReturnRegFieldKeys.Geography,
        defaultSheet: EA_LIST_SOURCE_DEFAULTS.geography.sheet,
        defaultAddress: formatListSourceColOpenValueRange(
            EA_LIST_SOURCE_DEFAULTS.geography.column,
            EA_LIST_SOURCE_DEFAULTS.geography.startRow
        ),
        defaultEndRow: EA_LIST_SOURCE_DEFAULTS.geography.endRow,
    },
    {
        rowKey: "ewcSource",
        label: "EWC code",
        regFieldKey: WasteReturnRegFieldKeys.Ewc,
        defaultSheet: EA_LIST_SOURCE_DEFAULTS.ewc.sheet,
        defaultAddress: formatListSourceColOpenValueRange(
            EA_LIST_SOURCE_DEFAULTS.ewc.column,
            EA_LIST_SOURCE_DEFAULTS.ewc.startRow
        ),
        defaultEndRow: EA_LIST_SOURCE_DEFAULTS.ewc.endRow,
    },
    {
        rowKey: "disposalRecoveryReceivedSource",
        label: "Disposal & Recovery Received",
        regFieldKey: WasteReturnRegFieldKeys.EaDrReceived,
        defaultSheet: EA_LIST_SOURCE_DEFAULTS.disposalRecoveryReceived.sheet,
        defaultAddress: formatListSourceColOpenValueRange(
            EA_LIST_SOURCE_DEFAULTS.disposalRecoveryReceived.column,
            EA_LIST_SOURCE_DEFAULTS.disposalRecoveryReceived.startRow
        ),
        defaultEndRow: EA_LIST_SOURCE_DEFAULTS.disposalRecoveryReceived.endRow,
    },
    {
        rowKey: "disposalRecoveryRemovedSource",
        label: "Disposal & Recovery Removed",
        regFieldKey: WasteReturnRegFieldKeys.EaDrRemoved,
        defaultSheet: EA_LIST_SOURCE_DEFAULTS.disposalRecoveryRemoved.sheet,
        defaultAddress: formatListSourceColOpenValueRange(
            EA_LIST_SOURCE_DEFAULTS.disposalRecoveryRemoved.column,
            EA_LIST_SOURCE_DEFAULTS.disposalRecoveryRemoved.startRow
        ),
        defaultEndRow: EA_LIST_SOURCE_DEFAULTS.disposalRecoveryRemoved.endRow,
    },
    {
        rowKey: "facilityOperationSource",
        label: "Facility operation",
        regFieldKey: WasteReturnRegFieldKeys.FacilityOperation,
        defaultSheet: EA_LIST_SOURCE_DEFAULTS.facilityOperation.sheet,
        defaultAddress: formatListSourceColOpenValueRange(
            EA_LIST_SOURCE_DEFAULTS.facilityOperation.column,
            EA_LIST_SOURCE_DEFAULTS.facilityOperation.startRow
        ),
        defaultEndRow: EA_LIST_SOURCE_DEFAULTS.facilityOperation.endRow,
    },
    {
        rowKey: "technicalCompetenceSource",
        label: "Competence scheme",
        regFieldKey: WasteReturnRegFieldKeys.TechnicalCompetence,
        defaultSheet: EA_LIST_SOURCE_DEFAULTS.technicalCompetence.sheet,
        defaultAddress: "TCM_List",
        defaultEndRow: EA_LIST_SOURCE_DEFAULTS.technicalCompetence.endRow,
    },
];

export const EA_WASTE_RETURN_DATA_SOURCES_SECTION_LABEL = "Data Sources";
